const normalize = (v?: any) => (v == null ? '' : String(v))

// Helper to extract team member names from resolved team structure
const getTeamMemberNames = (row: any): string => {
  const resolvedTeam = row?._resolvedTeam || {}
  const roles = ['AM', 'PM', 'DMS', 'SEO', 'MIA', 'BDE', 'QA', 'other']
  const names: string[] = []

  for (const role of roles) {
    const members = resolvedTeam[role] || []
    for (const member of members) {
      if (member?.name) names.push(member.name)
    }
  }

  return names.join(', ')
}

export const buildSearchIndex = (row: any) => {
  const parentBits = [
    row?.name,
    row?.website,
    row?.status,
    row?.trackingType,
    row?.primaryContact?.name,
    row?.owner?.name,
    // Include both old team_details and new role-based team
    (row?.team_details ?? []).map((u: any) => u?.name).join(', '),
    getTeamMemberNames(row),
    (row?.affiliated ?? []).map((o: any) => o?.name).join(', '),
    (row?.contractedBy ?? []).map((o: any) => o?.name).join(', '),
    row?.vertical,
    row?.orgNameReference,
    row?.type,
  ]

  const childBits = [
    row?.productName,
    row?.category,
    row?.childVertical,
    row?.orgNameReference,
    (row?.relatedContacts ?? []).map((c: any) => c?.name).join(', '),
    (row?.contractedByOrg ?? []).map((o: any) => o?.name).join(', '),
    row?.startDate,
    row?.endDate,
    row?.dealStatus,
    row?.org_type,
  ]

  const bits = row?.isParent ? parentBits : childBits
  return bits.map(normalize).filter(Boolean).join(' • ')
}
